var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerGeneric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 30 40",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 1c3.8676822 0 7.3698476 1.54388426 9.904675 4.04197501 2.529505 2.49284555 4.095325 5.93632169 4.095325 9.74063369 0 5.1798912-4.7554833 13.0630883-14.0008871 23.6972471-9.24422553-10.6351468-13.9991129-18.5176805-13.9991129-23.6972471 0-3.804312 1.56581996-7.24778814 4.095325-9.74063369 2.53482738-2.49809075 6.0369928-4.04197501 9.904675-4.04197501z",
    fill: "#fff",
    stroke: "#8ec752",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    fill: "#8ec752",
    r: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerGeneric);
export default __webpack_public_path__ + "static/media/map-marker-generic.3b44da88c7f6f3c5f1ecf02e80dddb9b.svg";
export { ForwardRef as ReactComponent };